import { IntroScreenUIConfig } from "../../components/ui/intro-screen-ui";
import { SingleScenarioInfoConfig } from "../../components/ui/scenario-info-ui";
import GameManager from "../../cvp-webgames-core/GameManager";
import BaseScenarioPart from "../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { SingleVideoSegmentItem, VideoSegmentItem } from "../../cvp-webgames-core/VideoSegment/VideoSegmentItem";
import { PreCacheItem, PrecacheItemType, SinglePreCacheItem } from "../../cvp-webgames-core/pre-caching/pre-cache-item";
import { PageType } from "../../misc/tools";
import { GameBaseScenario } from "../GameBaseScenario";
import PivBadgeComponentsStep0Component from "./components/piv-badge-components-step0/piv-badge-components-step0";
import PivBadgeComponentsStep0Part1 from "./components/piv-badge-components-step0/piv-badge-components-step0-parts/piv-badge-components-step0-part1";
import PivBadgeComponentsStep1Component from "./components/piv-badge-components-step1/piv-badge-components-step1";
import PivBadgeComponentsStep1Part1 from "./components/piv-badge-components-step1/piv-badge-components-step1-parts/piv-badge-components-step1-part1";
import PivBadgeComponentsStep2Component from "./components/piv-badge-components-step2/piv-badge-components-step2";
import PivBadgeComponentsStep2Part1 from "./components/piv-badge-components-step2/piv-badge-components-step2-parts/piv-badge-components-step2-part1";

class Scenario1PivBadgeVideoSegments extends VideoSegmentItem {
	public get title(): string {
		return 'Scenario 1 Piv Badge';
    }
	
	public getItems(): SingleVideoSegmentItem[] {
		return [
			{
				key: 'Scenario 1 Video 1',
				src: process.env.PUBLIC_URL + '/assets/videos/scenario01/sc01-cinematic/cin-sc-1.mp4',
				chapterIds: [
					'Chapter 1'
				]
			},
			{
				key: 'MixedMedia',
				src: process.env.PUBLIC_URL + '/assets/videos/scenario01/sc01-mentor/mntr-sc-01.mp4', //Need to add the audio files from the 3 employees after the mentor file finishes.
				chapterIds: [
					'step-2'// alan to update premiere file with audios lol at the end of the time code.
				]
			},
			{
				key: 'Feedback',
				src: process.env.PUBLIC_URL + '/assets/videos/scenario01/sc01-mentor/mntr-sc-01.mp4', // change this
				chapterIds: [
					'mentor-4', //question 1 correct - don't delete comment!
					'mentor-3', //question 1 incorrect - don't delete comment!
					'mentor-5', //question 1 other option - don't delete comment!
					'mentor-8',//question 2 correct - don't delete comment!
					'mentor-7', //question 2 incorrect - don't delete comment!
					'mentor-9', //question 2 other option - don't delete comment!
					'mentor-13', //question 3 correct - don't delete comment!
					'mentor-12', //question 3 incorrect - don't delete comment!
					'mentor-15', //question 4 correct - don't delete comment!
					'mentor-16', //question 4 incorrect - don't delete comment!
					'mentor-17', //question 4 other option - don't delete comment!
					'mentor-19', //question 5 correct - don't delete comment!
					'mentor-20', //question 5 incorrect - don't delete comment!
					'mentor-1', //scenario info 
					'mentor-21' //scenario review
				]
			}
		];
	}
}

export const scenario1PivBadgeVideoSegments = new Scenario1PivBadgeVideoSegments();

class Scenario1PivBadgeAudioCaching extends PreCacheItem {
    public audioKeys = {
        question1: 'question1',
        question2: 'question2',
        question3: 'question3',
        question4: 'question4',
        question5: 'question5'
    };
	public getItems(): SinglePreCacheItem[] {
		return [
			{
				type: PrecacheItemType.Audio,
				key: this.audioKeys.question1,
				src: process.env.PUBLIC_URL + '/assets/voiceover/scenario-01/mentor/jcdst-mentor-vo-scn-01-16.mp3'
			},
			{
				type: PrecacheItemType.Audio,
				key: this.audioKeys.question2,
				src: process.env.PUBLIC_URL + '/assets/voiceover/scenario-01/mentor/jcdst-mentor-vo-scn-01-03.mp3'
			},
			{
				type: PrecacheItemType.Audio,
				key: this.audioKeys.question3,
				src: process.env.PUBLIC_URL + '/assets/voiceover/scenario-01/mentor/jcdst-mentor-vo-scn-01-07.mp3'
			},
			{
				type: PrecacheItemType.Audio,
				key: this.audioKeys.question4,
				src: process.env.PUBLIC_URL + '/assets/voiceover/scenario-01/mentor/jcdst-mentor-vo-scn-01-02.mp3'
			},
			{
				type: PrecacheItemType.Audio,
				key: this.audioKeys.question5,
				src: process.env.PUBLIC_URL + '/assets/voiceover/scenario-01/mentor/jcdst-mentor-vo-scn-01-05.mp3'
			}
		];
	}
}

export const scenario1PivBadgeAudioCaching = new Scenario1PivBadgeAudioCaching();

export default class Scenario1PivBadge extends GameBaseScenario {
	public comp1Step1FirstSelectedChoiceIndex: number = -1;

	public getScenarioInfo(): SingleScenarioInfoConfig {
		return {
			scenarioId: PageType.Scenario1PivBadge,
			title: 'PIV Badge',
			subtitle: 'Situation/Background',
			img: process.env.PUBLIC_URL + '/assets/images/scenarios/sample-image.png',
			description: `
				<p class="small-text" style="margin: 20px; text-align: center">
				After this learning activity you will be able to apply the Just Culture Decision Support Tool after an adverse event occurs.
				
				DBRS entered, and police contacted after a volunteer became disruptive, upset, and 
				refused to leave Laura’s office. The volunteer was found using Laura’s computer, 
				while it was left unlocked.
				</p>
			`,
			mentorVideoUrl: scenario1PivBadgeVideoSegments.getItemByKey('Feedback').src,
			mentorChapterId: scenario1PivBadgeVideoSegments.getItemByKey('Feedback').chapterIds[13]
		}
    }

	public getMentorVideoURLs(): SingleVideoSegmentItem[] {
		return [
			scenario1PivBadgeVideoSegments.getItemByKey('MixedMedia'),
			scenario1PivBadgeVideoSegments.getItemByKey('Feedback'),
		] 
	}

	public resumeScenarioFromArea(areaIndx: number): void {
		switch(areaIndx) {
			case 0:
				(this.step0Component.parts[0] as PivBadgeComponentsStep0Part1).section2();
				break;
			case 1:
				(this.step0Component.parts[0] as PivBadgeComponentsStep0Part1).section3();
				break;
			case 2:
				(this.step1Component.parts[0] as PivBadgeComponentsStep1Part1).section2();
				break;
			case 3:
				(this.step1Component.parts[0] as PivBadgeComponentsStep1Part1).section3();
				break;
			case 4:
				(this.step2Component.parts[0] as PivBadgeComponentsStep2Part1).section1();
				break;
			case 5:
				(this.step2Component.parts[0] as PivBadgeComponentsStep2Part1).section2();
				break;
			case 6:
				(this.step1Component.parts[0] as PivBadgeComponentsStep1Part1).section1();
				break;
		}
	}

	//VALUES BELOW ARE FOR DEBUG PURPOSES IN CASE STEP 1 is SKIPPED
	// public comp1Step1FirstSelectedChoiceIndex: number = 0;

	public scenarioId(): PageType {
		return PageType.Scenario1PivBadge;
    }
	private video: SingleVideoSegmentItem = scenario1PivBadgeVideoSegments.getItemByKey('Scenario 1 Video 1');

	public getScenarioVideoURL(): string {
		return this.video.src;
	}


	public introScreenInfo(): IntroScreenUIConfig {
		return {
			title: 'PIV Badge',
			subtitle: 'Incident Report',
			name: 'Laura',
			position: 'Health System Specialist',
			time: '10:00 am',
			place: 'Room #3352',
			desc: `DBRS entered and police contacted after a volunteer became disruptive, 
			upset and refused to leave Laura\'s office. The volunteer was found 
			using Laura\'s computer, while it was left unlocked.`,
			repeat: 'Yes',
			okButton: 'Continue'
		}
	}

	private step0Component = new PivBadgeComponentsStep0Component({
		scenario: this,
		onDone: () => {
			this.goToStep1Component();
		}
	})

	private step1Component = new PivBadgeComponentsStep1Component({
		scenario: this,
		onDone: () => {
			this.goToStep2Component();
		}
	})

	private step2Component = new PivBadgeComponentsStep2Component({
		scenario: this,
		onDone: () => {
			this.uiWrapper.displayAAR();
		}
	})

	private parts: BaseScenarioPart<GameBaseScenario>[] = [].concat(this.step0Component.parts)
		.concat(this.step1Component.parts)
		.concat(this.step2Component.parts);

	constructor(gameManager: GameManager, scenarioName: string) {
		super(gameManager, scenarioName);
		this._setupStep0Component();
		this._setupStep1Component();
		this._setupStep2Component();
	}

	start() {
		this.goToStep0Component();
	}

	private _setupStep0Component() {
		this.step0Component.config.part1Config = {
			chapter: () => {
				return this.video.chapterIds[0];
			},
			videoUrl: this.video.src
		}
	}

	private _setupStep1Component() {
		this.step1Component.config.part1Config = {
			chapter: () => {
				return this.video.chapterIds[0];
			},
			videoUrl: this.video.src
		}
	}

	private _setupStep2Component() {
		this.step2Component.config.part1Config = {
			videoUrl: this.video.src
		}
	}

	public getParts(): BaseScenarioPart<GameBaseScenario>[] {
		return this.parts;
	}

	public getSoundPath(fileName: string): string {
		return process.env.PUBLIC_URL + '/assets/audio/scenario1/' + fileName + '.ogg';
	}

	goToStep0Component() {
		this.step0Component.start();
	}

	goToStep1Component() {
		this.step1Component.start();
	}

	goToStep2Component() {
		this.step2Component.start();
	}
}